import React from 'react'
import Lottie from 'lottie-react'
import * as animationData from '@public/lottie/network.json'

export const NetworkLottie = () => {
	return (
		<Lottie
			animationData={animationData}
			loop={true}
			style={{
				width: 400,
				height: 400,
			}}
			rendererSettings={{ preserveAspectRatio: 'xMidYMid slice' }}
		/>
	)
}
